import React from "react";

// Always suppress (hardcoded)
export const CookiesConsent: React.FC = () => {
  return null;
};
